<template>
  <div class="goods">
    <div class="goods-item" v-for="item of list" :key="item.goods_sn" @click="routerTo(item)">
      <div class="goods-pic">
        <img :src="item.pic" />
      </div>
    <div class="goods-item-info"> 
        <div class="goods-item-name">
          {{ item.goods_name }}
        </div>
        <div class="goods-item-price">
          <span>到手价</span>
          {{  $setInfoDecimal(item.goods_price) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    routerTo (item) {
       this.$router.push({
          name: 'prodetail',
          query: {
            pid: item.goods_sn,
            type: 'activity'
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .goods{
    font-size: 0.2rem;
    margin: 0 0.1rem;
    .goods-item {
      width: 6.6rem;
      margin: 17px auto;
      height: 4.24rem;
      background: url("../../../../assets/activites/box.png") 0/100% no-repeat;
      position: relative;
      display: flex;
      align-items: center;
      padding: 0.3rem;
      .goods-item-info{
        height: 2.85rem;
        margin-left: 0.3rem;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        font-family: PingFang SC;
      }
      .goods-item-name{
        font-size: 0.3rem;
        color: #666666;
        width: 3rem;
        word-wrap: break-word;
      }
      .goods-item-price{
        color: #D23123;
        font-size: 0.4rem;
        span{
          color: #666666;
          font-size: 0.2rem
        }
      }
      .goods-pic {
        width: 2.85rem;
        height: 2.85rem;
        border-radius: 10px;
      }
    }
  }
</style>